<script setup lang="ts">
import LanguageSelector from '@kidzonet/language-selector'
</script>

<template>
    <LanguageSelector
        label=""
        variant="plain"
        class="dashboard-language-selector"
    />
</template>

<style>
    .dashboard-language-selector {
        box-sizing: border-box;

        .language-selector-item {
            font-size: 14px;
        }
    }
</style>
